(ns app.components.pop-ups.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))



(defclass restore-folders-pop-up-style
  [] {:background-color :theme/*dark21*
      :bottom 0})

(defclass popper-style
  [] {:bottom "unset"
      :z-index 2
      :top "10% !important"
      :right "50%"
      :left "45% !important"
      :display "flex"
      :justify-content "center"
      :align-items "center"
      :width "495px"
      :border-radius "6px"
      :background-color "#2B2A35"})

(defclass popup-button-style
  [] {:color "#EBEBFF" :background-color "#2B2A35"})

(defclass parent-checkbox-style
  [] {:color "#EBEBFF" :background-color "#2B2A35"})
